import Community from './Community';

export default Community;
